<template>
  <portal selector="#app">
    <div ref="curtainWrapper" @contextmenu.prevent.stop class="fixed inset-0 items-center justify-center hidden z-max">
      <div
        ref="curtainOverlay"
        @click="hide()"
        @touchmove="dragAllowed ? activeTabElement && activeTabElement.onDrag($event) : ''"
        @touchend="dragAllowed ? activeTabElement && activeTabElement.onDragEnd($event) : ''"
        @touchcancel="dragAllowed ? activeTabElement && activeTabElement.onDragEnd($event) : ''"
        @mousemove="dragAllowed ? activeTabElement && activeTabElement.onDrag($event) : ''"
        @mouseup="dragAllowed ? activeTabElement && activeTabElement.onDragEnd($event) : ''"
        class="absolute inset-0 z-50 duration-200 opacity-0"
        :class="{'bg-black/50': this.theme === 'light', 'bg-white/50': this.theme === 'dark'}"
      ></div>
      <slot></slot>
    </div>
  </portal>
</template>

<script>
  import handleViewport from '@/utils/mixins/handleViewport'
  import {mapGetters} from 'vuex'
  export default {
    name: 't-curtain',
    props: {
      dragMode: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        visible: false
      }
    },
    mixins: [handleViewport],
    computed: {
      ...mapGetters(['theme']),
      dragAllowed() {
        if (this.viewport.width >= this.$screen.md) return false
        return this.dragMode
      },
      activeGroup() {
        const activeTab = this.$children[0].$children.find(child => child.$options.name === 't-curtain-tab' && child.active)
        return activeTab ? activeTab.group : null
      },
      activeTabElement() {
        return this.$children[0].$children.filter(
          child => child.$options.name === 't-curtain-tab' && child._props.group === this.activeGroup && child.active
        )[0]
      }
    },
    methods: {
      show(group = 'default') {
        const tabs = this.$children[0].$children.filter(
          child => child.$options.name === 't-curtain-tab' && child._props.group === group
        )
        if (tabs.length === 0) return
        if (!tabs.some(tab => tab.active)) {
          tabs[0].first = true
          tabs[0].active = true
          tabs[0].canAdvanceBackwards = false
          tabs[0].back = this.back
          tabs[0].close = this.hide
          tabs[0].curtainWrapper = this.$refs.curtainWrapper
          tabs[0].curtainOverlay = this.$refs.curtainOverlay
          this.visible = true
          return
        }
      },
      forward() {
        const tabs = this.$children[0].$children.filter(
          child => child.$options.name === 't-curtain-tab' && child._props.group === this.activeGroup
        )
        const index = tabs.findIndex(tab => tab.active) + 1
        if (index === tabs.length) return
        this.activeTabElement.active = false
        tabs[index].first = false
        tabs[index].active = true
        tabs[index].canAdvanceBackwards = true
        tabs[index].back = this.back
        tabs[index].close = this.hide
        tabs[index].curtainWrapper = this.$refs.curtainWrapper
        tabs[index].curtainOverlay = this.$refs.curtainOverlay
        this.visible = true
      },
      back() {
        const tabs = this.$children[0].$children.filter(
          child => child.$options.name === 't-curtain-tab' && child._props.group === this.activeGroup
        )
        const index = tabs.findIndex(tab => tab.active) - 1
        if (index < 0) return
        if (index === 0) tabs[index].canAdvanceBackwards = false
        else tabs[index].canAdvanceBackwards = true
        this.activeTabElement.active = false
        tabs[index].active = true
        tabs[index].first = false
        tabs[index].back = this.back
        tabs[index].close = this.hide
        tabs[index].curtainWrapper = this.$refs.curtainWrapper
        tabs[index].curtainOverlay = this.$refs.curtainOverlay
        this.visible = true
      },
      tab(name) {
        const [group, tabName] = name.split('/')
        const tabs = this.$children[0].$children.filter(
          child => child.$options.name === 't-curtain-tab' && child._props.group === group
        )
        const tab = this.$children[0].$children.find(
          child => child.$options.name === 't-curtain-tab' && child._props.group === group && child.name === tabName
        )
        if (!tab) return
        const index = tabs.indexOf(tab) + 1
        if (index === 1) tab.canAdvanceBackwards = false
        else tab.canAdvanceBackwards = true
        if (this.activeTabElement && this.activeTabElement.active) {
          // switching from separate tabs (e.g. from second to last or event between separate groups)
          this.activeTabElement.active = false
          setTimeout(() => {
            tab.first = false
            tab.active = true
            tab.back = this.back
            tab.close = this.hide
            tab.curtainWrapper = this.$refs.curtainWrapper
            tab.curtainOverlay = this.$refs.curtainOverlay
            this.visible = true
          })
        } else {
          tab.first = true
          tab.active = true
          tab.back = this.back
          tab.close = this.hide
          tab.curtainWrapper = this.$refs.curtainWrapper
          tab.curtainOverlay = this.$refs.curtainOverlay
          this.visible = true
        }
      },
      hide(emittable = true) {
        const tabs = this.$children[0].$children.filter(
          child => child.$options.name === 't-curtain-tab' && child._props.group === this.activeGroup
        )
        const index = tabs.findIndex(tab => tab.active)
        tabs[index].hide()
        this.visible = false
        if (emittable) this.$emit('close')
      }
    }
  }
</script>
